// extracted by mini-css-extract-plugin
export default {"qr_container":"QR_qr_container__R7qqI"};